import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { BasePagingResponse } from "../_types";

export type GetSendApprovedChangeRequestListRequest = {
  roleLevel?: number;
  makerUserId?: number;
  startDate?: string;
  endDate?: string;
  status?: string;
}

export type ISendApprovedChangeRequest = {
  roleLevel?: number;
  makerUserId?: number;
  startDate?: string;
  endDate?: string;
  status?: string;
}

export type GetSendApprovedChangeRequestListResponse = BasePagingResponse<Array<ISendApprovedChangeRequest>>;

async function getSendApprovedChangeRequestList(data: GetSendApprovedChangeRequestListRequest): Promise<GetSendApprovedChangeRequestListResponse> {
  try {
    return (await axiosInstance.post("/ChangeRequest/ListSendApproved", data))
      .data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetSendApprovedChangeRequestList() {
  return useMutation<GetSendApprovedChangeRequestListResponse, Error, GetSendApprovedChangeRequestListRequest>((variables) =>
    getSendApprovedChangeRequestList(variables)
  );
}
